export const swapPosOfTwoArrayItems = <T>(arr: T[], index1: number, index2: number): T[] => {
	const newArr = [...arr] // Create a shallow copy to avoid mutating the original array
	;[newArr[index1], newArr[index2]] = [newArr[index2], newArr[index1]] // Swap the items
	return newArr // Return the new array
}

export const pushIfNotExists = <T>(array: T[], element: T): void => {
	if (!array.includes(element)) {
		array.push(element)
	}
}
